<template>
  <div
    v-if="packages.length > 0"
    id="addToCartVue"
    class="purchasing"
  >
    <hr>

    <div id="packageForm">
      <h2 class="pricing_header">
        {{ $t('formPackage.packagePricing') }}
        <CurrencyDropdown @currency-emit="updateCurrency" />
      </h2>

      <br>

      <div class="heading">
        <label class="occupancy-desc">
          {{ $t('formPackage.chooseYourPackage') }}
        </label>
      </div>

      <br>

      <PackageInputFields
        :currency="currency"
        :rate="rate"
        :packages="packages"
        @qty-emit="updatePackageQty"
        @package-emit="updateSelectedPackage"
      />

      <HotelInputFields
        :pack="selectedPackage"
        :package-qty="packageQty"
        @qty-emit="updateHotelQty"
        @hotel-emit="updateSelectedHotel"
      />

      <div class="new_order_item">
        <AddToCart
          :form-btn-text="formBtnText"
          :qtyhotel="hotelQty"
          :qtypackage="packageQty"
          :idhotel="idHotel"
          :idpackage="idPackage"
          :idstay="idStay"
        />

        <PriceInfo
          :currency="currency"
          :hotel="selectedHotel"
          :hotel-qty="hotelQty"
          :pack="selectedPackage"
          :package-qty="packageQty"
          :rate="rate"
          :stay="selectedStay"
        />
      </div>

      <span class="tax_disclaimer small">
        {{ $t('taxDisclaimer') }}
      </span>

      <CurrencyDisclaimer
        :currency="currency"
        :chargeablecurrencies="chargeableCurrencies"
      />
    </div>
  </div>
</template>

<script>
import { CurrencyDropdown,
  CurrencyDisclaimer } from '../../../default/currency_convert'
import AddToCart from './add-to-cart'
import HotelInputFields from './hotel-input'
import PackageInputFields from './package-input-fields'
import PriceInfo from './price-info'

export default {
  components: {
    AddToCart,
    CurrencyDisclaimer,
    CurrencyDropdown,
    HotelInputFields,
    PackageInputFields,
    PriceInfo
  },

  data() {
    return {
      chargeableCurrencies: [],
      currency: 'USD',
      hotelQty: 0,
      packageQty: 1,
      packages: [],
      rate: 1.0,
      selectedHotel: null,
      selectedPackage: null,
      selectedStay: null,
    }
  },

  computed: {
    formBtnText() {
      return this.$t('formPackage.addToCart')
    },

    idHotel() {
      if (this.selectedHotel) {
        return this.selectedHotel.id
      } else {
        return null
      }
    },

    idPackage() {
      if (this.selectedPackage) {
        return this.selectedPackage.id
      } else {
        return null
      }
    },

    idStay() {
      if (this.selectedStay) {
        return this.selectedStay.id
      } else {
        return null
      }
    }
  },

  created() {
    let packageDiv = document.getElementById('packageCartFormData')

    if (packageDiv) {
      this.packages = JSON.parse(packageDiv.dataset.packages)
      packageDiv.parentNode.removeChild(packageDiv)

      this.chargeableCurrencies = this.packages[0].chargeable_currencies
    }
  },

  methods: {
    updateCurrency(errors, currency, rate) {
      if (currency && rate) {
        this.currency = currency
        this.rate = rate
      }
    },

    updateHotelQty(qty) {
      if (qty) { this.hotelQty = qty }
    },

    updatePackageQty(qty) {
      if (qty) { this.packageQty = qty }
    },

    updateSelectedHotel(hotelFields) {
      this.selectedHotel = hotelFields.hotel
      this.selectedStay = hotelFields.stay
    },

    updateSelectedPackage(pack) {
      if (pack) { this.selectedPackage = pack }
    }
  }
}
</script>
